import React from "react";
import NumberFormat from "react-number-format";
import {
    TextField, 
    Checkbox, 
    Tooltip,
} from "@mui/material";


// ✅ Use forwardRef so MUI can attach a ref to this input component
const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        if (onChange) {
          onChange({
            target: {
              name,
              value: values.value,
            },
          });
        }
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      isNumericString
    />
  );
});

export default NumberFormatCustom;


// note Column+View for status !== 0 || 4 

export const columnPoView = () => ([
    {
        field: "poNo",
        headerName: "PO Number",
        headerClassName: "super-app-theme--header",
        editable: false,
        flex: 1,
        minwidth: 140,
      },
      {
        field: "costCenter",
        headerName: "Cost Center",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "createBy",
        headerName: "Created By",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 140,
      },
      {
        field: "paymentTerm",
        headerName: "Payment Term",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "paymentIn",
        headerName: "Payment In",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "companyCode",
        headerName: "Company Code",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "poType",
        headerName: "PO Type",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
        renderCell: (cellValues) => {
          switch (cellValues.row.poType) {
            case 0:return <p>Non Trade</p>
            case 1:return <p>Trade</p>
            default:
              return null
          }
        },
      },
      {
        field: "purchaseOrganization",
        headerName: "Purchasing Org",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "purchaseGroup",
        headerName: "Purch. Group",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "exchangeRate",
        headerName: "Exchange rate",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "incoterms",
        headerName: "Incoterms",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
      },
      {
        field: "incotermsDesc",
        headerName: "Incoterms Desc",
        headerClassName: "super-app-theme--header",
        editable: false,
        flex: 1,
        minwidth: 160,
      },
]);

export const columnItemListView = () => ([
    {
        field: "poNo",
        headerName: "PO Number",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 140,
    },
    {
        field: "item",
        headerName: "Item",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 60,
    },
    {
        field: "awbInvoiceNo",
        headerName: "AWB/INV NO",
        headerClassName: "super-app-theme--header",
        editable: false,
        flex:1,
        minwidth: 160,
    },
    {
        field: "material",
        headerName: "Material",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 140,
    },
    {
        field: "shortText",
        headerName: "Short Text (Item)",
        headerClassName: "super-app-theme--header",
        editable: false,
        flex: 1,
        minwidth: 160,
    },
    {
        field: "condition",
        headerName: "CnTy",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
    },
    {
        field: "conditionDesc",
        headerName: "Cnty Desc",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
    },
    {
  field: "quantity",
  headerName: "Qty",
  headerClassName: "super-app-theme--header",
  editable: false,
  type: 'number',
  width: 120,
  renderCell: (cellValues) => {
            if(cellValues.row.quantity !== null && cellValues.row.quantity !== undefined){
            return <NumberFormat displayType="text" decimalScale={2} thousandSeparator="." decimalSeparator="," value={cellValues.row.quantity} />
            }
        },
}
,
    {
        field: "currency",
        headerName: "Curr",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 60,
    },
    {
        field: "netValue",
        headerName: "Net Value",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
        renderCell: (cellValues) => {
            if(cellValues.row.netValue !== null && cellValues.row.netValue !== undefined){
            return <NumberFormat displayType="text" decimalScale={2} thousandSeparator="." decimalSeparator="," value={cellValues.row.netValue} />
            }
        },
    },
    {
        field: "itemStatus",
        headerName: "Item Status",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 140,
    },
    {
        field: "grStatus",
        headerName: "GR Status",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 120,
    },
    {
        field: "billedQty",
        headerName: "Billed Qty",
        headerClassName: "super-app-theme--header",
        editable: false,
        type: 'number',
        width: 90,
         renderCell: (cellValues) => {
          return (
            <input
              disabled={true}
              value={cellValues.row.billedQty}
              className="input-BilledQty"
              id="billedQty"
              name="billedQty"
              type="number"
            />
          );
        },
    },
    {
        field: "amountInvoice",
        headerName: "Amount Inv.",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 160,
        disableExport:true
    },
]);

export const columnItemTypeView = (data,dropdownWht,dropdownWhtType,dropdownWhtSubType) => ([
    {
        field: "itemTypeDesc",
        headerName: "Item Type",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 160,
      },
      {
  field: "itemTypeAmount",
  headerName: "Amount",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 120,
  renderCell: (cellValues) => {
    const value = cellValues.row.itemTypeAmount;
    const hasWarning = data.TotalAmountItemType === true;

    return (
      <TextField
        disabled
        margin="none"
        value={value ?? ""}
        name="itemTypeAmount"
        size="small"
        InputProps={{
          inputComponent: NumberFormatCustom,
          className: hasWarning ? "input-amountType-warning" : "input-amountType",
        }}
      />
    );
  },
},
      {
  field: "itemTypeVat",
  headerName: "VAT",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 160,
  renderCell: (cellValues) => {
    const { vat, checkVat } = cellValues.row;

    if (vat === 1) {
      return (
        <Checkbox
          name="itemTypeVat"
          disabled
          checked={Boolean(checkVat)}
        />
      );
    }

    return <span>-</span>; // visual fallback for consistency
  },
},
      {
  field: "itemTypeVatRate",
  headerName: "VAT Rate",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 140,
  renderCell: (cellValues) => {
    const { vat, itemTypeVatRate } = cellValues.row;

    if (vat === 1 && typeof itemTypeVatRate === "number") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <NumberFormat
            value={itemTypeVatRate}
            displayType="text"
            decimalScale={2}
            thousandSeparator="."
            decimalSeparator=","
            className="input-BilledQty"
          />
          <p style={{ marginLeft: "8px" }}>%</p>
        </div>
      );
    }

    return <span>-</span>;
  },
},
     {
  field: "itemTypeDppAmount",
  headerName: "DPP Amount",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 160,
  renderCell: (cellValues) => {
    const { vat, itemTypeDppAmount } = cellValues.row;

    if (vat === 1 && typeof itemTypeDppAmount === "number") {
      return (
        <NumberFormat
          displayType="text"
          decimalScale={2}
          thousandSeparator="."
          decimalSeparator=","
          value={itemTypeDppAmount}
        />
      );
    }

    return <span>-</span>;
  },
},
      {
  field: "itemTypeVatAmount",
  headerName: "VAT Amount",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 160,
  renderCell: (cellValues) => {
    const { vat, itemTypeVatAmount } = cellValues.row;

    if (vat === 1 && typeof itemTypeVatAmount === "number") {
      return (
        <NumberFormat
          displayType="text"
          decimalScale={2}
          thousandSeparator="."
          decimalSeparator=","
          value={itemTypeVatAmount}
        />
      );
    }

    return <span>-</span>;
  },
},
      {
  field: "itemTypeWht",
  headerName: "Wht",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 160,
  renderCell: (cellValues) => {
    const { wht, checkWht } = cellValues.row;

    if (wht === 1) {
      return (
        <Checkbox
          disabled
          name="itemTypeWht"
          checked={Boolean(checkWht)} // ensure it's a boolean
        />
      );
    }

    return <span>-</span>; // or use an empty cell with placeholder
  },
},
     {
  field: "whtType",
  headerName: "Wht Type",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 120,
  renderCell: (cellValues) => {
    const rawValue = cellValues.row?.itemTypeWhtType;
    const label = rawValue != null && rawValue !== "" ? String(rawValue) : "-";

    return label !== "-" ? (
      <Tooltip title={label}>
        <span className="table-cell-trucate">{label}</span>
      </Tooltip>
    ) : (
      <span className="table-cell-trucate">-</span>
    );
  },
},
     {
  field: "whtSubType",
  headerName: "Wht Sub Type",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 120,
  renderCell: (cellValues) => {
    const findData = dropdownWht.find(
      (d) =>
        d.companyCode === data.companyCode &&
        d.taxType === cellValues.row.itemTypeWhtType &&
        d.serviceType === cellValues.row.itemTypeWhtSubtype
    );

    const serviceType = findData?.serviceType;

    return serviceType ? (
      <Tooltip title={serviceType}>
        <span className="table-cell-trucate">{serviceType}</span>
      </Tooltip>
    ) : (
      <span className="table-cell-trucate">-</span>
    );
  },
},
    {
  field: "itemTypeWhtRate",
  headerName: "Wht Rate",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 120,
  renderCell: (cellValues) => {
    const rate = cellValues.row.itemTypeWhtRate;

    return typeof rate === "number" ? (
      <div style={{ display: "flex", alignItems: "center" }}>
        <NumberFormat
          value={rate}
          displayType="text"
          decimalScale={2}
          thousandSeparator="."
          decimalSeparator=","
          className="input-BilledQty"
        />
        <p style={{ marginLeft: "8px" }}>%</p>
      </div>
    ) : (
      <span className="table-cell-trucate">-</span>
    );
  },
},
   {
  field: "itemTypeWhtAmount",
  headerName: "Wht Amount",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 120,
  renderCell: (cellValues) => {
    const { wht, itemTypeWhtAmount } = cellValues.row;

    if (wht === 1 && typeof itemTypeWhtAmount === "number") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <NumberFormat
            value={itemTypeWhtAmount}
            displayType="text"
            decimalScale={2}
            thousandSeparator="."
            decimalSeparator=","
            className="input-BilledQty"
          />
        </div>
      );
    }

    return <span>-</span>;
  },
},
   {
  field: "itemTypeWhtAmountToBePaid",
  headerName: "Amount To Be Paid",
  headerClassName: "super-app-theme--header",
  editable: false,
  width: 140,
  renderCell: (cellValues) => {
    const value = cellValues.row.itemTypeWhtAmountToBePaid;

    if (typeof value === "number") {
      return (
        <NumberFormat
          displayType="text"
          value={value} // Biarkan sebagai number, JANGAN toFixed
          decimalScale={2}
          fixedDecimalScale
          thousandSeparator="."
          decimalSeparator=","
        />
      );
    }

    return <span>-</span>; // fallback for undefined/null
  },
}
,
])


export const columnSupportDocumentView = (handleDownloadFile) => ([
    {
        field: "documentName",
        headerName: "Document Name",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 490,
        renderCell:(cellValues)=>{
          return <p className={cellValues.row.mandatory === true ?"mandatory-doc":undefined}>{cellValues.row.documentName}</p>
  
        }
      },
      {
        field: "documentNo",
        headerName: "Document No",
        headerClassName: "super-app-theme--header",
        editable: false,
        width: 310,
        renderCell:(cellValues)=>{
          return <input className="input-document-no" disabled={true}  name="documentNo" value={cellValues.row.documentNo === "null" ?null:cellValues.row.documentNo}   />
        }
      },
      {
        field: "fileName",
        headerName: "Upload File",
        headerClassName: "super-app-theme--header",
        editable: false,
        flex: 1,
        minwidth: 400,
        renderCell: (cellValues) => {
          return (
              <p className="uploadFile-name" onClick={()=>handleDownloadFile(cellValues.row)} >{cellValues.row.fileName}</p>
          );
        },
      },
])